var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C3.41015 0.5 0.5 3.41015 0.5 7V17C0.5 20.5898 3.41015 23.5 7 23.5H17C20.5898 23.5 23.5 20.5899 23.5 17V7C23.5 3.41015 20.5899 0.5 17 0.5H7Z",
    stroke: "#003764",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOutline);
export default __webpack_public_path__ + "static/media/checkBoxOutline.96f0f17723b23706a7f5e86ea6ddea54.svg";
export { ForwardRef as ReactComponent };